var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FFFAEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.501 32H17.626C16.452 32 15.501 31.049 15.501 29.875V19.855C15.501 19.568 15.559 19.283 15.672 19.02L16.839 16.29C17.173 15.508 17.942 15 18.793 15H29.21C30.061 15 30.829 15.508 31.164 16.29L32.331 19.02C32.443 19.284 32.501 19.568 32.501 19.855V24",
    stroke: "#F79009",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.001 15V19.44",
    stroke: "#F79009",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.457 19.4404H15.543",
    stroke: "#F79009",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 28H20.5",
    stroke: "#F79009",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.501 33C26.74 33 24.501 30.761 24.501 28C24.501 25.239 26.74 23 29.501 23C32.263 23 34.501 25.239 34.501 28C34.501 30.761 32.263 33 29.501 33",
    stroke: "#F79009",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2724 27.4831L31.6774 27.0781C32.0424 27.9391 31.8744 28.9711 31.1724 29.6721C30.6094 30.2351 29.8354 30.4471 29.1074 30.3221",
    stroke: "#F79009",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7291 28.5174L27.3241 28.9224C26.9591 28.0614 27.1271 27.0294 27.8291 26.3284C28.4261 25.7314 29.2621 25.5304 30.0281 25.7054",
    stroke: "#F79009",
    strokeWidth: 1.46498,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.fa04734921f635bae619c0b566b8ad67.svg";
export { ForwardRef as ReactComponent };